<template>
  <div class="outer-tool">
    <div class="card door" v-if="activeColor!=='carC7'">
      <div class="card-item">
        <div class="card-item-top">
          <div class="ping door-item" :class="{active:doorPing}" @click="changeDoor(true)">
            <div class="dd">
              <div class="c-dd"></div>
            </div>
            <span>平开式车门</span>
          </div>
          <div class="wai door-item" :class="{active:!doorPing}" @click="changeDoor(false)">
            <div class="dd">
              <div class="c-dd"></div>
            </div>
            <span>外摆式电动门</span>
          </div>
        </div>
      </div>
    </div>
    <div class="function card">
      <div class="card-item">
        <div class="card-item-top" :class="{active:openFunction}" @click="funClick">
          <img class="icon" src="~img/function.png" alt="">
          <div class="label">功能点</div>
          <div class="btn">
            <div class="switch" :class="{open:openFunction}">
              <div class="dot"></div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="card-group card">
      <div class="card-item" v-for="item in toolList" :key="item.key">
        <div class="card-item-top" @click="setOpenTool(item.key)" :class="{active:openTool===item.key}">
          <img class="icon" :src="require(`img/${item.key}.png`)" alt="">
          <div class="label" :class="{hideSpan:!!openTool}" v-html="`${isMobile ? '' : '选择'}${item.label}`"></div>
          <div class="btn">
            <div class="arrow" :class="{up:openTool===item.key}"></div>
          </div>
        </div>
        <div class="card-item-content" v-show="openTool===item.key&&openTool!=='car'">
          <template v-if="openTool!=='car'">
            <div class="card-content-item" v-for="cit in item.value" :key="cit.value"
                 @click="changeOuter(item.key,cit.value)"
                 :class="{active:cit.value===activeTool[item.key]}">
              <div class="cit-icon-box">
                <img class="cit-icon" :src="require(`img/${cit.value}.png`)"/>
              </div>
              <div class="cit-label">{{ cit.label }}</div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {carConfig} from "@/config";
import app from "@/utils/app";
import {isMobile} from "@/utils";

const toolKeys = ['wheel', 'callipers', 'doorborder']

if (isMobile) {
  toolKeys.unshift('car')
}

export default {
  props:['activeColor'],
  data() {
    const toolList = []
    const activeTool = {}
    toolKeys.forEach(key => {
      toolList.push({
        key,
        ...carConfig[key],
      });
      activeTool[key] = carConfig[`default_${key}`]
    })

    return {
      carConfig,
      openTool: '',
      openFunction: false,
      toolList,
      activeTool,
      isMobile,
      doorPing: true,
      doorAnirun:false
    }
  },
  watch:{
    openTool(val){
      console.log(val)
      this.$emit('hideSpan',val)
    },
    activeColor(val){
      if(val==='carC7'){
        this.doorPing=true
      }
    }
  },
  methods: {
    funClick() {
      this.openFunction = !this.openFunction
      app.setHotspotStatus(this.openFunction)
    },
    changeDoor(type){
      if(this.doorAnirun)return
      if(this.doorPing!==type){
        this.doorPing = type
        if(type)app.carDoorOneAnimation()
        else app.carDoorTowAnimation()
        setTimeout(()=>{
          this.doorAnirun = false
        },3000)
      }
    },
    setOpenTool(key) {
      if( this.openTool === key){
        key=''
      }
      this.openTool = key
      this.$emit('setShowMobileColor', key === 'car')
    },
    changeOuter(accessory, styleName) {
      this.activeTool[accessory] = styleName;
      app.changeOutConfig(accessory, styleName)
    }
  }
}
</script>
